import React from 'react';

export default function Logo({ size = 'md' }) {
  const heights = { sm: 28, md: 44, lg: 72 };
  return (
    <img
      src="/logo.png"
      alt="Impekble — Cleaning for superhosts"
      className="ik-logo-img"
      style={{ height: heights[size] || heights.md }}
    />
  );
}
